var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { SubscribeGameIncidentsQueryInfo, PullGameIncidentsQueryInfo } from "sb-bff-integration";
import { InternalMessageBusChannels } from "sb-internal-msg-bus";
import { observable, action } from "mobx";
import { entities } from "sbtech-sports-data-api-client";
import { IncidentTypes } from "../../Constants";
export class IncidentsRetriever {
    constructor(data) {
        this.incidents = [];
        this.ids = [];
        this.gateway = data.gateway;
        this.messageBus = data.messageBus;
        this.incidentsSubscription = undefined;
        this.updateEventIds = this.updateEventIds.bind(this);
    }
    activate() {
        this.messageBus.on(InternalMessageBusChannels.aggregatedEvents.ids.update, this.updateEventIds);
        //this.requestAggregatedEventId();
    }
    deactivate() {
        this.messageBus.off(InternalMessageBusChannels.aggregatedEvents.ids.update, this.updateEventIds);
        this.unsubscribe();
        this.incidents = [];
        this.ids = [];
    }
    /*requestAggregatedEventId() {
        this.messageBus.emit(InternalMessageBusChannels.aggregatedEvents.currentId.request, {requestCurrentAggregatedEventId:true});
    }*/
    updateEventIds(message) {
        let messageData = message.data;
        if (messageData[0] && messageData[0].ids && messageData[0].ids.length) {
            this.ids = message.data[0].ids;
            this.pullGameIncidents(this.getPullIncidentsQuery(this.ids));
        }
    }
    pullGameIncidents(incidentsQuery) {
        this.gateway.pullGameIncidents(incidentsQuery);
    }
    subscribeForIncidents(incidentsQuery) {
        this.unsubscribe();
        this.incidentsSubscription = this.gateway.subscribeForGameIncidents(incidentsQuery);
    }
    unsubscribe() {
        this.incidentsSubscription && this.incidentsSubscription.unsubscribe();
    }
    getPullIncidentsQuery(ids) {
        return new PullGameIncidentsQueryInfo(ids.join(","), this.updateIncidents, undefined, IncidentTypes.join(","), 20);
    }
    getSubscribeIncidentsQuery(ids) {
        return new SubscribeGameIncidentsQueryInfo(ids.join(","), this.addIncident, undefined, IncidentTypes.join(","));
    }
    updateIncidents(response) {
        this.incidents = response && response.length ? response : [];
        this.subscribeForIncidents(this.getSubscribeIncidentsQuery(this.ids));
    }
    addIncident(response) {
        if (response && response.id) {
            this.incidents = [response];
        }
    }
}
__decorate([
    observable,
    __metadata("design:type", Array)
], IncidentsRetriever.prototype, "incidents", void 0);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array]),
    __metadata("design:returntype", void 0)
], IncidentsRetriever.prototype, "updateIncidents", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], IncidentsRetriever.prototype, "addIncident", null);
//# sourceMappingURL=IncidentsRetriever.js.map